import StorageManager from './StorageManager'

const GIFT_NOTE_KEY = 'giftNote'

class GiftNoteManager {
  getGiftNote() {
    return StorageManager.get(GIFT_NOTE_KEY)
  }

  setGiftNote(giftNote) {
    StorageManager.set(GIFT_NOTE_KEY, giftNote)
  }

  clearData() {
    StorageManager.remove(GIFT_NOTE_KEY)
  }
}

export const giftNoteManager = new GiftNoteManager()
